import $ from "jquery";

$('ul.tabs li a').click(function(e) {
    e.preventDefault();
    var tab_id = $(this).attr('href');

    $('ul.tabs li a').removeClass('active');
    $('.tab-pane__content').removeClass('active');

    $(this).addClass('active');
    $(tab_id).addClass('active');
});

$('.tab-pane__title a').click(function() {
    var $this = $(this);
    var $parent = $this.parents('.tab-pane__content');
    var $openedBoxes = $('.tab-pane__content.active');

    if($parent.length) {
        $('.tab-pane__title a').removeClass('active');

        if($openedBoxes.length) {
            $openedBoxes.each(function(index, box) {

            if(box === $parent[0]) {
                $openedBoxes.splice(index, 1);
            }
            });
            
            if($openedBoxes.length) {
                $openedBoxes.removeClass('active');
            }
        }

        $parent.toggleClass('active');
    }
});

// Click on button single product 
$('.simulation-link').on('click',function() {
    $('.tabs a[href="#financement"]').toggleClass('active');
    $('div#financement').toggleClass('active');

    $('.tabs a[href="#options"]').toggleClass('active');
    $('div#options').toggleClass('active');

});